export const TableEmptyState = ({ children }: { children: string }) => {
	return (
		<p className="px-4 py-8 text-center text-sm whitespace-pre-wrap text-gray-500">
			{children}
		</p>
	)
}
